<template>
  <ion-page>
    <ion-content class="ion-padding">
      <ion-grid
        fixed
        style="
          display: flex;
          flex-direction: column;
          min-height: 100%;
          padding-top: var(--ion-safe-area-top, 0);
        ">
        <!-- <div> -->
        <ion-row>
          <ion-col>
            <img
              width="100"
              src="@/assets/img/roodie_logo_white.svg"
              alt="Roodie Logo" />
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <h1>
              <b
                >Hallo<template v-if="$store.state.user.Initials === 'F'">
                  Frau</template
                ><template v-else-if="$store.state.user.Initials === 'M'">
                  Herr</template
                ><template v-if="$store.state.user.LastName">
                  {{ " " + $store.state.user.LastName }}</template
                >,</b
              >
            </h1>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="auto">
            <p>
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/white/icon_vorbeugung_folgeerkrankungen.svg')
                " />
            </p>
          </ion-col>
          <ion-col>
            <p>
              <b>Ihre Gesundheit. Unser Anliegen.</b><br />
              Egal, ob Sie einen Arzt oder eine Klinik suchen oder schon in
              Behandlung sind: Mit der Hilfe von Roodie kommen Sie schnell zum
              richtigen Arzt.
            </p>
          </ion-col>
          <ion-col size="12" class="ion-text-center">
            <div class="c-iframe ion-margin-vertical">
              <div class="c-iframe__wrapper">
                <iframe
                  id="video"
                  class="c-iframe__video"
                  width="560"
                  height="315"
                  src="https://player.vimeo.com/video/601096133"
                  title="Vimeo video player"
                  frameborder="0"
                  allow="autoplay"
                  allowfullscreen
                  webkitallowfullscreen
                  mozallowfullscreen></iframe>
              </div>
            </div>
            <!-- <img
              src="@/assets/img/video-mock.png"
              class="ion-margin-vertical"
            /> -->
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="auto">
            <p>
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/white/icon_ernaehrung.svg')" />
            </p>
          </ion-col>
          <ion-col>
            <p><b>An diesen Themen arbeiten wir noch:</b></p>
            <!-- <ion-row style="align-items: center;">
              <ion-col size="auto">
                <ion-icon
                  size="large"
                  :src="
                    require('@lib/assets/icons/white/icon_koerpliche_aktivitaet.svg')
                  "
                />
              </ion-col>
              <ion-col>
                <b>Physiotherapie</b>
              </ion-col>
            </ion-row>
            <ion-row style="align-items: center;">
              <ion-col size="auto">
                <ion-icon
                  size="large"
                  :src="
                    require('@lib/assets/icons/white/icon_mentale_gesundheit.svg')
                  "
                />
              </ion-col>
              <ion-col>
                <b>Mentale Gesundheit</b>
              </ion-col>
            </ion-row>
            <ion-row style="align-items: center;">
              <ion-col size="auto">
                <ion-icon
                  size="large"
                  :src="
                    require('@lib/assets/icons/white/icon_kinderwunsch.svg')
                  "
                />
              </ion-col>
              <ion-col>
                <b>Schwangerschaft/Kinderwunsch</b>
              </ion-col>
            </ion-row> -->
          </ion-col>
        </ion-row>
        <ion-list lines="none" style="background: transparent">
          <ion-item class="u-item-white">
            <ion-toggle
              @click="
                toggleUserTag(
                  'smsPhysiotherapy',
                  'sms-physiotherapy-yes',
                  false
                )
              "
              v-model="smsPhysiotherapy"
              slot="start">
            </ion-toggle>
            <ion-label class="ion-text-wrap"><b>Physiotherapie</b></ion-label>
            <ion-icon
              size="large"
              :src="
                require('@lib/assets/icons/white/icon_koerpliche_aktivitaet.svg')
              "
              slot="end" />
          </ion-item>
          <ion-item class="u-item-white">
            <ion-toggle
              @click="
                toggleUserTag('smsMentalhealth', 'sms-mentalhealth-yes', false)
              "
              v-model="smsMentalhealth"
              slot="start">
            </ion-toggle>
            <ion-label class="ion-text-wrap"
              ><b>Mentale Gesundheit</b></ion-label
            >
            <ion-icon
              size="large"
              :src="
                require('@lib/assets/icons/white/icon_mentale_gesundheit.svg')
              "
              slot="end" />
          </ion-item>
          <ion-item class="u-item-white">
            <ion-toggle
              @click="toggleUserTag('smsPregnancy', 'sms-pregnancy-yes', false)"
              v-model="smsPregnancy"
              slot="start">
            </ion-toggle>
            <ion-label class="ion-text-wrap ion-no-margin"
              ><b>Schwangerschaft/<wbr />Kinderwunsch</b></ion-label
            >
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/white/icon_kinderwunsch.svg')"
              slot="end" />
          </ion-item>
        </ion-list>
        <ion-row>
          <ion-col>
            <p>
              Klicken Sie bitte an, wofür Sie sich interessieren und wir
              benachrichtigen Sie, sobald wir Ihnen auch zu diesen Themen helfen
              können.
            </p>
            <p>
              Wenn Sie akut ärztlichen Rat oder Hilfe benötigen, wenden Sie sich
              bitte an den ärztlichen Bereitschaftsdienst. Im Notfall rufen Sie
              bitte die Notrufnummer 112 an.
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-right">
            <ion-button
              fill="outline"
              color="light"
              v-on:click="goToDashboard()">
              Weiter
            </ion-button>
            <!-- <ion-button
              fill="outline"
              color="light"
              v-on:click="addUserTag('new-topics')"
            >
              Ja
            </ion-button> -->
          </ion-col>
        </ion-row>
        <branding style="margin-top: auto" />
        <!-- </div> -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonContent,
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
  toastController,
  IonItem,
  IonLabel,
  IonToggle,
  IonList,
} from "@ionic/vue";
import Branding from "@/components/Branding";
import { apiAddUserTag, apiRemoveUserTag } from "@/api/user";

export default {
  components: {
    IonPage,
    IonContent,
    IonButton,
    IonIcon,
    IonGrid,
    IonRow,
    IonCol,
    Branding,
    IonItem,
    IonLabel,
    IonToggle,
    IonList,
  },
  data() {
    return {
      smsPhysiotherapy: false,
      smsMentalhealth: false,
      smsPregnancy: false,
    };
  },
  methods: {
    async toggleUserTag(dataName, tag, isNegation = true) {
      this.$store.commit("setShowLoading", true);
      let response = null;
      if (isNegation) {
        if (this[dataName]) {
          response = await apiAddUserTag(tag);
        } else {
          response = await apiRemoveUserTag(tag);
        }
      } else {
        if (!this[dataName]) {
          response = await apiAddUserTag(tag);
        } else {
          response = await apiRemoveUserTag(tag);
        }
      }
      if (response?.data?.Status !== "Success") {
        this[dataName] = !this[dataName];
      }
    },
    async addUserTag(tag) {
      this.$store.commit("setShowLoading", true);
      const response = await apiAddUserTag(tag);
      if (response.data.Status === "Success") {
        const toast = await toastController.create({
          message:
            "Wir informieren Sie, sobald Ihnen die zusätzlichen Themen zur Verfügung stehen.",
          duration: 5000,
        });
        toast.present();
        modalController.dismiss();
      }
    },
    goToDashboard() {
      // this.$router.push({
      //   name: "home",
      //   params: { showBiometricSetup: "true" },
      // });
      modalController.dismiss();
    },
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped>
ion-content {
  --background: var(--ion-color-primary);
  --color: white;
}
</style>
